/**
 * @generated SignedSource<<0d35163187222f20e007ada54f5c825e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type resourceIconFragment$data = {
  readonly displayLink: string;
  readonly entityType: string;
  readonly iconUrl: string;
  readonly isExternal: boolean;
  readonly " $fragmentType": "resourceIconFragment";
};
export type resourceIconFragment$key = {
  readonly " $data"?: resourceIconFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"resourceIconFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "resourceIconFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "entityType"
      },
      "action": "THROW",
      "path": "entityType"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "displayLink"
      },
      "action": "THROW",
      "path": "displayLink"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      "action": "THROW",
      "path": "iconUrl"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "isExternal"
      },
      "action": "THROW",
      "path": "isExternal"
    }
  ],
  "type": "HelpObjectStoreSearchResult"
};

(node as any).hash = "61adf56879f78dbab16536f41b38d4cf";

export default node;
